module.exports = __webpack_public_path__ + "img/head_logo.411f81ff.png";